import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import TradePartnerSubmissions from '../component/list/TradePartnerSubmissions';

function TablePage(props) {

  return (
    <ScopedCssBaseline>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <TradePartnerSubmissions />
      </Box>
    </ScopedCssBaseline>);
};

export default TablePage;